import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { ProductCardComponent } from '../../components/product-card/product-card.component';
import { Page } from '../../model/page.model';
import { Product } from '../../model/product.model';
import { ProductService } from '../../service/product.service';
import { StateService } from '../../service/state.service';


@Component({
  selector: 'app-shop',
  standalone: true,
  imports: [
    CommonModule,
    ProductCardComponent,
  ],
  templateUrl: './shop.component.html',
  styleUrl: './shop.component.scss'
})
export class ShopComponent implements OnInit {

  products: Product[] = [];
  page: Page = { pageNo: 1, pageSize: 100 };
  unsubscribe$ = new Subject();

  constructor(private product: ProductService, private stateService: StateService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.stateService.shimmerLoaderUpdate(true);
    this.product.getAllProducts(this.page).pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res:any) => {
          this.products = [...res.data.list].sort((a, b) => b.mrp - a.mrp);
          this.stateService.shimmerLoaderUpdate(false);
        },
        error: (err:any) => {
          this.toastr.error("Something Went Wrong")
          this.stateService.shimmerLoaderUpdate(false)
        }
      })
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

}
